'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_signing_SigningApi$$anon$3(outer) {
  this.bXG = null;
  this.bXE = null;
  this.bXF = false;
  this.bXC = null;
  this.bXD = false;
  this.bXH = false;
  this.bXI = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bXG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_signing_SigningApi$$anon$3 as $c_Lpresto_pages_signing_SigningApi$$anon$3 };
$p = $c_Lpresto_pages_signing_SigningApi$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_signing_SigningApi$$anon$3;
/** @constructor */
function $h_Lpresto_pages_signing_SigningApi$$anon$3() {
}
export { $h_Lpresto_pages_signing_SigningApi$$anon$3 as $h_Lpresto_pages_signing_SigningApi$$anon$3 };
$h_Lpresto_pages_signing_SigningApi$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bXG;
});
$p.t = (function() {
  if ((!this.bXF)) {
    this.bXE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("reason", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bXF = true;
  }
  return this.bXE;
});
$p.ag = (function() {
  if ((!this.bXD)) {
    this.bXC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bXD = true;
  }
  return this.bXC;
});
$p.v = (function() {
  if ((!this.bXI)) {
    this.bXH = false;
    this.bXI = true;
  }
  return this.bXH;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_signing_SigningApi$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_signing_SigningApi$$anon$3, "presto.pages.signing.SigningApi$$anon$3", ({
  Xn: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_signing_SigningApi$$anon$3 as $d_Lpresto_pages_signing_SigningApi$$anon$3 };
//# sourceMappingURL=presto.pages.signing.-Signing-Api$$anon$3.js.map
